/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'bad2': {
    width: 16,
    height: 16,
    viewBox: '0 0 22.76 22.76',
    data: '<defs/><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><circle pid="0" class="cls-1" cx="11.38" cy="11.38" r="10.88"/><circle pid="1" class="cls-2" cx="7.22" cy="9.3" r="1.64"/><circle pid="2" class="cls-2" cx="15.94" cy="9.3" r="1.64"/><path pid="3" class="cls-1" d="M17.58 17.3s-1.1-2.5-5.8-2.5-6.2 2.5-6.2 2.5"/></g></g>'
  }
})



// WEBPACK FOOTER //
// ./src/icons/bad2.js